// @flow strict
import { type ComponentType } from "react";
import styled from "styled-components";

const Description: ComponentType<{}> = styled.p`
  margin: 5px;
`;

export default Description;
